import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "isEditable", "isTooltipLoaded", "onClick", "showTooltip", "tooltipPlacement", "tooltipTitle", "size"];
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import AvatarWrapper from './AvatarWrapper';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AvatarHover(_ref) {
  let {
      children,
      isEditable,
      isTooltipLoaded,
      onClick,
      showTooltip,
      tooltipPlacement,
      tooltipTitle,
      size
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const cssStyles = useMapTokenPropsToCSS(rest);
  if (!isEditable && showTooltip && isTooltipLoaded) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: tooltipTitle,
      placement: tooltipPlacement,
      "data-test-id": "AvatarDisplay-tooltip",
      children: /*#__PURE__*/_jsx(AvatarWrapper, {
        "data-test-id": "AvatarDisplay-switchComponent",
        "data-tooltip-loaded": isTooltipLoaded,
        $cssStyles: cssStyles,
        $size: size,
        onClick: onClick,
        children: children
      })
    });
  }
  return /*#__PURE__*/_jsx(AvatarWrapper, {
    "data-test-id": "AvatarDisplay-switchComponent",
    $cssStyles: cssStyles,
    $size: size,
    onClick: onClick,
    children: children
  });
}